module.exports = __webpack_public_path__ + "media/speak.fd2334e9.wav";